export default __webpack_public_path__ + "static/media/template_9.32bc4d48.svg";